import { FC } from "react";
//#region types
import { EndMonthInputProps } from "models/propTypes/benefitsPropTypes";
import { DateConstants, IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { FormControl, Grid } from "@mui/material";
import { Icon, MonthPicker } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const EndMonthInput: FC<EndMonthInputProps> = (props) => {
  const onChange = (date?: Date) => {
    props.setValue({
      ...props.value,
      end: date,
    });
  };
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        wrap="nowrap"
        gap={2}
        className={clsx(props.className, cssExports.monthRangeEndMonthInput)}
      >
        <Grid item className={cssExports.month}>
          {props.value.start
            ? LocalizationHelperInstance.getFormattedDate(props.value.start, DateConstants.MonthYearNumericConfig)
            : ""}
        </Grid>
        <Grid item alignSelf={"center"} className={cssExports.separatorIcon}>
          <Icon icon={IconDefinitionConstants.WArrowSmallRight} />
        </Grid>
        <Grid item>
          <MonthPicker
            selected={props.value.end ?? undefined}
            startDate={props.value.start ?? undefined}
            endDate={props.value.end}
            onChange={onChange}
            error={props.error}
            label={props.label ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EndDate)}
            placeholderText={
              props.placeholderText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EndDate)
            }
            minDate={props.value.start ?? props.minDate}
            onBlur={props.onBlur}
            setLastDayOfMonth
            className={props.className}
            name={props.name}
            popperProps={{ strategy: "fixed" }}
            data-testid={`${props.name}MonthInput`}
            disabled={props.disabled}
            hideClearable={props.disabled}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default EndMonthInput;
